import APIConfiguration from '@savgroup-front-common/configuration/src/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/src/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/customerfile/${COMMON_QUERY_PARAMS.FILE_ID}/outcome`;

export interface UpdateFileOutcomeCommandPayload {
  fileId: string;
  closing: string;
}

async function updateFileOutcomeCommand({
  fileId,
  closing,
}: UpdateFileOutcomeCommandPayload): Promise<BaseBackResponse> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

    return await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        closing,
      },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default updateFileOutcomeCommand;
